import AddInsurancePopup from "./AddInsurancePopup";

function InsuranceModal({
  show,
  handleClose,
  handleInsuranceCreation,
  onCreated,
  insurance = null,
  activeTab = "parties",
  initialTab,
  deleteInsuranceHandler,
  onDelete,
  addInsurance = false,
  billData,
  partyScope = "all",
  initialParty = null,
}) {
  return (
    <AddInsurancePopup
      show={show}
      handleClose={handleClose}
      onCreated={onCreated || handleInsuranceCreation}
      insurance={addInsurance ? null : insurance}
      onDelete={onDelete || deleteInsuranceHandler}
      initialTab={addInsurance ? "parties" : initialTab || activeTab}
      initialParty={initialParty}
      preferInitialParty={Boolean(initialParty?.id)}
      partyScope={partyScope}
      billData={billData}
    />
  );
}

export default InsuranceModal;
